import {
  HOME_GET_TEMPLATES_BEGIN,
  HOME_GET_TEMPLATES_SUCCESS,
  HOME_GET_TEMPLATES_FAILURE,
  HOME_GET_TEMPLATES_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
export function getTemplates(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_GET_TEMPLATES_BEGIN,
    });
    const { page, size } = args;
    const params = {
      page,
      size,
    };
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
      params,
    };
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE_URL}usecase-template/templates`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_GET_TEMPLATES_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: HOME_GET_TEMPLATES_FAILURE,
            data: { error: err },
          });
          reject(err);
          console.log('error>>>>>getTemplates', err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetTemplatesError() {
  return {
    type: HOME_GET_TEMPLATES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_GET_TEMPLATES_BEGIN:
      return {
        ...state,
        getTemplatesPending: true,
        getTemplatesError: null,
      };

    case HOME_GET_TEMPLATES_SUCCESS:
      return {
        ...state,
        getTemplatesPending: false,
        getTemplatesError: null,
        templatesData: action.data,
      };

    case HOME_GET_TEMPLATES_FAILURE:
      return {
        ...state,
        getTemplatesPending: false,
        getTemplatesError: action.data.error,
      };

    case HOME_GET_TEMPLATES_DISMISS_ERROR:
      return {
        ...state,
        getTemplatesError: null,
      };

    default:
      return state;
  }
}
